import React from 'react';
import { string, func, bool, array, object, number } from 'prop-types';
import { get } from 'lodash';
import { Text, Button, FormInput, FormDatePicker, Icon } from '../../../common';
import {
    OrderSection,
    SectionCard,
    PinTopRow,
    PinInputWrapper,
    PinButtonWrapper,
    DateFilterBox,
    DateFilterIcon,
    FilterCounter,
    ErrorAlert,
    ErrorContent,
    ErrorTitle,
    ErrorMessage
} from '../styles';
import PendingOrders from './PendingOrders';

const PinSection = ({
    storeName,
    pin,
    onChange,
    onValidate,
    loading,
    error,
    pendingOrders,
    loadingProducts,
    onOrderEyeClick,
    onErrorClose,
    defaultFrom,
    defaultTo,
    dateResetKey,
    onDateFromChange,
    onDateToChange,
    onClearFilters
}) => {
    const count = pendingOrders ? pendingOrders.length : 0;

    return (
        <OrderSection>
            <SectionCard>
                {/* Store Name */}
                {storeName && (
                    <div style={{ marginBottom: 20 }}>
                        <Text text={storeName.toUpperCase()} strong size={24} />
                    </div>
                )}

                {/* PIN + Ver pedido */}
                <PinTopRow>
                    <PinInputWrapper>
                        <FormInput
                            label='PIN'
                            placeholder='Ingrese el pin de registro'
                            value={pin}
                            onChange={({ target }) => onChange(get(target, 'value', '').toUpperCase())}
                            style={{ margin: 0 }}
                        />
                    </PinInputWrapper>
                    <PinButtonWrapper>
                        <Button
                            backgroundColor='#1FA02E'
                            text='Ver pedido'
                            action='action_name'
                            onClick={onValidate}
                            disabled={!pin || loading}
                            style={{ height: 34, minWidth: 200, border: 0 }}
                        />
                    </PinButtonWrapper>
                </PinTopRow>

                {/* Error Message */}
                {error && (
                    <div style={{ marginBottom: 20 }}>
                        <ErrorAlert>
                            <Icon name='alert-circle' size={28} color='#BD2C00' />
                            <ErrorContent>
                                <ErrorTitle>PIN inválido</ErrorTitle>
                                <ErrorMessage>{error}</ErrorMessage>
                            </ErrorContent>
                            {onErrorClose && (
                                <Icon
                                    name='close'
                                    size={20}
                                    color='#BD2C00'
                                    style={{ cursor: 'pointer', marginLeft: 'auto', alignSelf: 'flex-start' }}
                                    onClick={onErrorClose}
                                />
                            )}
                        </ErrorAlert>
                    </div>
                )}

                {/* Caja de filtro de fechas (Desde / Hasta) */}
                <DateFilterBox>
                    <DateFilterIcon>
                        <Icon name='calendar' size={18} color='#888888' />
                    </DateFilterIcon>
                    <FormDatePicker
                        key={`from-${dateResetKey}`}
                        label='Desde'
                        defaultValue={defaultFrom}
                        onChange={([selected]) => onDateFromChange(selected)}
                        position='absolute'
                        width='160px'
                        style={{ margin: 0 }}
                    />
                    <FormDatePicker
                        key={`to-${dateResetKey}`}
                        label='Hasta'
                        defaultValue={defaultTo}
                        onChange={([selected]) => onDateToChange(selected)}
                        position='absolute'
                        width='160px'
                        style={{ margin: 0 }}
                    />
                    <Button
                        link
                        text='Limpiar'
                        onClick={onClearFilters}
                        fitContent
                        style={{ fontSize: 12 }}
                    />
                </DateFilterBox>

                {/* Contador */}
                <FilterCounter>
                    Pedidos pendientes: <strong>{count}</strong>
                </FilterCounter>

                {/* Tabla de pedidos con detalle agrupado por orden */}
                <PendingOrders
                    orders={pendingOrders}
                    loading={loadingProducts}
                    onEyeClick={onOrderEyeClick}
                />
            </SectionCard>
        </OrderSection>
    );
};

PinSection.propTypes = {
    storeName: string,
    pin: string,
    onChange: func.isRequired,
    onValidate: func.isRequired,
    loading: bool,
    error: string,
    pendingOrders: array,
    loadingProducts: bool,
    onOrderEyeClick: func,
    onErrorClose: func,
    defaultFrom: object,
    defaultTo: object,
    dateResetKey: number,
    onDateFromChange: func,
    onDateToChange: func,
    onClearFilters: func
};

PinSection.defaultProps = {
    storeName: '',
    pin: '',
    loading: false,
    error: null,
    pendingOrders: [],
    loadingProducts: false,
    onOrderEyeClick: null,
    onErrorClose: null,
    defaultFrom: undefined,
    defaultTo: undefined,
    dateResetKey: 0,
    onDateFromChange: () => {},
    onDateToChange: () => {},
    onClearFilters: () => {}
};

export default PinSection;
